var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 50.5,
    cy: 50.5,
    r: 50.5,
    fill: "#808191"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9997 50C57.443 50 62.6663 44.7767 62.6663 38.3334C62.6663 31.89 57.443 26.6667 50.9997 26.6667C44.5564 26.6667 39.333 31.89 39.333 38.3334C39.333 44.7767 44.5564 50 50.9997 50Z",
    fill: "#808191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9996 55.8333C39.3096 55.8333 29.7896 63.6733 29.7896 73.3333C29.7896 73.9866 30.3029 74.5 30.9562 74.5H71.0429C71.6962 74.5 72.2096 73.9866 72.2096 73.3333C72.2096 63.6733 62.6896 55.8333 50.9996 55.8333Z",
    fill: "#808191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user_placeholder.ea111d25d5255d7df5613cae72df9ebc.svg";
export { ForwardRef as ReactComponent };